import { memo, type ReactElement } from 'react'

function SuccessCheckIcon (): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-786 -271)">
          <g transform="translate(341 197)">
            <g transform="translate(445.5 74)">
              <circle cx="15" cy="15" r="15" fill="#00AB63" />
              <path
                fill="#FFF"
                d="M12.482 18.427c-2.301-3.309-4.248-7.74-8.732-3.309 3.186 2.364 4.956 5.79 6.313 9.572.059.236.354.354.59.295 1.003-.236 2.006-.473 2.95-.709.177-.06.295-.118.354-.295C17.32 17.127 21.45 11.16 26.11 5.843c.413-.414-.177-1.064-.649-.768-5.014 3.19-9.38 7.621-12.98 13.352"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default memo(SuccessCheckIcon)
